<div id="overlay">
  <div class="flex flex-column positioning">
    <div class="main">
      <div class="flex flex-space-between">
        <div class="main-title">{{ "TransferFailure.Error" | translate }}</div>
        <app-close-icon
          class="closeIcon"
          [imageWidth]="25"
          [imageHeight]="25"
          (click)="closePopup()"
        ></app-close-icon>
      </div>
      <hr />
      <div class="flex flex-column main-text">
        <div
          class="flex flex-column align-items-center"
          *ngIf="requestType == 'transfer'; else transactionHistory"
        >
          <div>{{ "TransferFailure.TransferFailed" | translate }}</div>
          <div>{{ "TransferFailure.ReachOut" | translate }}</div>
          <a href="@mailto:mobilecredentials@allegion.com"
            >mobilecredentials&#64;allegion.com</a
          >
          <div>{{ "TransferFailure.Persists" | translate }}</div>
        </div>
        <ng-template #transactionHistory>
          <div>
            {{ "TransferFailure.TransactionHistoryFailed" | translate }}
          </div>
          <div>{{ "TransferFailure.ReachOut" | translate }}</div>
          <a href="@mailto:mobilecredentials@allegion.com"
            >mobilecredentials&#64;allegion.com</a
          >
          <div>{{ "TransferFailure.Persists" | translate }}</div>
        </ng-template>
        <app-transfer-failure-icon
          class="main-text--icon"
          [imageWidth]="200"
          [imageHeight]="200"
        ></app-transfer-failure-icon>
      </div>
      <div class="flex buttonSection">
        <div class="flex flex-space-between buttonSection-buttons">
          <app-button
            buttonColor="accent"
            buttonClass="buttonStyle buttonStyle-outlined"
            [buttonText]="'TransferFailure.Close' | translate"
            [buttonLinkActive]="false"
            (click)="closePopup()"
          ></app-button>
          <app-button
            buttonColor="primary"
            [buttonText]="'TransferFailure.TryAgain' | translate"
            buttonClass="buttonStyle buttonStyle-default"
            [buttonLinkActive]="false"
            (click)="tryAgainHandler.emit(); closePopup()"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
